import { useEffect, useState } from 'react';

// Android Foundation: Negocio360 sigue siendo online-first/offline-tolerant — este banner solo
// informa que no hay red; no implementa ventas/pagos offline ni cola de sincronización.
export function ConnectivityBanner() {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div className="connectivity-banner" role="status">
      Sin conexión. Los datos mostrados pueden no estar actualizados.
    </div>
  );
}
